module.exports = __webpack_public_path__ + "images/181_160.jpg";